import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { PricingConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { PricingService } from './api/pricing.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class PricingApiModule {
    public static forRoot(configurationFactory: () => PricingConfiguration): ModuleWithProviders<PricingApiModule> {
        return {
            ngModule: PricingApiModule,
            providers: [ { provide: PricingConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: PricingApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('PricingApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
